// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_k0-0";
export var fileCarousel = "_k0-2";
export var removeFileButton = "_k0-1";